import { Condition } from "generated/graphql";

export const conditionOptions: Array<{ value: Condition; label: string }> = [
  { label: "Excellent", value: Condition.Excellent },
  { label: "Good", value: Condition.Good },
  { label: "Fair", value: Condition.Fair },
  { label: "Poor", value: Condition.Poor },
  { label: "Very poor", value: Condition.VeryPoor },
];
